import React, { useEffect, useState } from "react";
import { ClockIcon } from "lucide-react";
const TOTAL_SECONDS = 17 * 60 + 34; // 00:17:34

function format(n: number) {
  return n.toString().padStart(2, "0");
}
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor(seconds % 3600 / 60);
  const secs = seconds % 60;
  const Box = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-35" data-mp="1aek8donl35ke">
      <span className="min-w-[2.75rem] rounded-lg bg-[#3d2b30] px-2 py-1.5 text-center font-serif-display text-2xl font-bold tabular-nums text-white sm:min-w-[3.25rem] sm:text-3xl" data-id="element-36" data-mp="15ephvm7q0hzv">
        {value}
      </span>
      <span className="mt-1 text-[0.6rem] font-bold uppercase tracking-widest text-[#8a3a52]" data-id="element-37" data-mp="2zsyt7xvhe8am">
        {label}
      </span>
    </div>;
  return <div className="flex flex-col items-center gap-2" data-id="element-38" data-mp="1gzrrbsmm3buh">
      <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-[#8a3a52]" data-id="element-39" data-mp="1h1cnfmokr2ug">
        <ClockIcon className="h-3.5 w-3.5" data-id="element-40" data-mp="124bu5eqqiztv" />
        La oferta termina en
      </div>
      <div className="flex items-center gap-2" data-id="element-41" data-mp="1723yx9chagfh">
        <Box value={format(hrs)} label="Horas" data-id="element-42" data-mp="1urg5e1gf8ae3" />
        <span className="font-serif-display text-2xl font-bold text-[#a04a63]" data-id="element-43" data-mp="1uroj1vkdbjqc">:</span>
        <Box value={format(mins)} label="Min" data-id="element-44" data-mp="1zp7z910mm6kx" />
        <span className="font-serif-display text-2xl font-bold text-[#a04a63]" data-id="element-45" data-mp="1zs3u2gh6gf55">:</span>
        <Box value={format(secs)} label="Seg" data-id="element-46" data-mp="1kzadssu2zuzf" />
      </div>
    </div>;
}